import React from "react";
import { Menu, Nav } from "../../../shared/components/ui/menu/Menu";
import { useSelector } from "react-redux";
import MENUTABS from "../../constants/menuTabs";

const LeftSideMenu = ({ dynamicTabs, className, forceCompact = false }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <Menu className={className} canClosed={true} overlayBreakpoint={1030} forceCompact={forceCompact}>
            {MENUTABS.map(tab => 
                <Nav
                    key={tab.route}
                    title={texts[tab.titleKey]}
                    icon={tab.icon}
                    to={`/${tab.route}`}
                />
            )}
            {dynamicTabs?.map(tab =>
                <Nav
                    key={tab.key}
                    title={texts[tab.titleKey]}
                    icon={tab.icon}
                    to={tab.route}
                />
            )}
        </Menu>

    );
};

export default LeftSideMenu;